import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  background: #fff;
  height: ${({ $isSetHeight }) => ($isSetHeight ? "calc(100vh - 298px)" : "auto")};
  overflow-y: auto;
`;

export const Content = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 32px 16px;

  @media screen and (min-width: 768px) {
    padding: 32px 0;
    margin: 50px auto 0 auto;
  }
`;

export const Header = styled.header`
  padding: 22px 0;
  border-bottom: 1px solid #eaeaea;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
`;

export const ApplicationCard = styled.div`
  border-radius: 8px;
  background: #f5f5f5;
  padding: 16px;
  margin-bottom: 32px;

  @media screen and (min-width: 768px) {
    padding: 24px;
  }
`;

export const Applying = styled.div`
  color: #333;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin-bottom: 8px;
`;

export const JobInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  gap: 24px;
`;

export const CompanyLogo = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 8px;
  border: 1px solid #f3f3f3;
  background: #fff;
  padding: 6px;
  align-items: center;
  justify-content: center;
  flex: none;
  display: none;

  img {
    width: 100%;
    max-height: 100%;
  }

  @media screen and (min-width: 768px) {
    display: flex;
  }
`;

export const JobTitle = styled.h2`
  color: #333;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 4px;
`;

export const CompanyInfo = styled.p`
  color: #666;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 8px;

  &:last-child {
    margin-bottom: 0;
  }

  svg {
    fill: #666666;
    width: 16px;
    height: 16px;
  }
`;

export const InfoMessage = styled.div`
  color: #333;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  display: flex;
  gap: 8px;
  align-items: flex-start;

  svg {
    fill: #408bfc;
    width: 24px;
    height: 24px;
    flex: none;
  }

  @media screen and (min-width: 768px) {
    align-items: center;
  }
`;

export const BenefitTitle = styled.h6`
  color: #333;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin: 0 0 16px;
`;

export const ContentSection = styled.div`
  text-align: center;
  max-width: 400px;
  margin: 0 auto 24px;
`;

export const SectionTitle = styled.h2`
  color: #333;
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 120%;
  margin-bottom: 24px;

  @media screen and (min-width: 768px) {
    font-size: 32px;
  }
`;

export const BenefitsList = styled.div`
  margin-bottom: 24px;

  @media screen and (min-width: 768px) {
    padding-left: 30px;
  }
`;

export const BenefitItem = styled.div`
  color: #333;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;

  &:last-of-type {
    margin-bottom: 0;
  }

  svg {
    width: 24px;
    height: 24px;
    fill: #408bfc;
    flex: none;
  }

  span {
    text-align: left;
  }

  @media screen and (min-width: 768px) {
    span {
      flex: none;
    }
  }
`;

const buttonStyles = css`
  background: ${({ $background }) => $background || "#fada5e"};
  color: ${({ $color }) => $color || "#000"};
  border: none;
  border-radius: 5px;
  padding: 14px 0;
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  line-height: 20px;
  display: block;
  text-decoration: none;
  text-align: center;
`;

export const JoinNow = styled(Link)`
  ${buttonStyles};
`;

export const Submit = styled.button`
  ${buttonStyles};
  position: relative;

  &:disabled {
    pointer-events: none;
  }

  div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const Divider = styled.div`
  color: #666;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  margin: 24px 0;
  position: relative;

  &::before,
  &::after {
    content: "";
    display: inline-block;
    width: 45%;
    height: 1px;
    background-color: #eee;
    position: absolute;
    top: 50%;
  }

  &::before {
    left: 0;
  }

  &::after {
    right: 0;
  }
`;

export const GuestButton = styled.a`
  background-color: #fff;
  border: 1px solid #c5c5c5;
  border-radius: 8px;
  color: #333;
  padding: 15px 0;
  font-size: 16px;
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  display: block;
  width: 100%;
  text-align: center;
  text-decoration: none;
`;

export const Flex = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
`;

const loginStyles = css`
  color: #408bfc;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  cursor: pointer;
  text-decoration: none;
  background-color: transparent;
`;

export const LoginButton = styled.button`
  ${loginStyles};
`;

export const LoginLink = styled(Link)`
  ${loginStyles};
`;

export const BackTo = styled(Link)`
  ${loginStyles};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;

  svg {
    width: 16px;
    height: 16px;
    fill: #408bfc;
  }
`;

export const Label = styled.span`
  color: #666;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
`;
